var _filter, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppropriatenessAssessmentQuestionTwo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": titleId,
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "brightness"
  }, /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncR", {
    type: "linear",
    slope: 0.65
  }), /*#__PURE__*/React.createElement("feFuncG", {
    type: "linear",
    slope: 0.65
  }), /*#__PURE__*/React.createElement("feFuncB", {
    type: "linear",
    slope: 0.65
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.594 83C64.5658 83 83.1881 64.4198 83.1881 41.5C83.1881 18.5802 64.5658 0 41.594 0C18.6223 0 0 18.5802 0 41.5C0 64.4198 18.6223 83 41.594 83Z",
    fill: "#242D33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 46.2656C44.132 46.2656 46.2656 44.132 46.2656 41.5C46.2656 38.868 44.132 36.7344 41.5 36.7344C38.868 36.7344 36.7344 38.868 36.7344 41.5C36.7344 44.132 38.868 46.2656 41.5 46.2656Z",
    fill: "#415360"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6875 46.2656L31.9687 43.4062L35.7812 32.9219L31.9687 31.0156L27.448 41.5639C26.7475 43.1994 27.2708 45.1028 28.71 46.1493L36.7343 51.9844V57.7031L34.8281 71.0469H39.5937L41.5 59.6094L43.4062 71.0469H48.1718L46.2656 57.7031V51.9844L54.29 46.1484C55.7292 45.1019 56.2524 43.1985 55.5519 41.5629L51.0312 31.0156L47.2187 32.9219L51.0312 43.4062L45.3125 46.2656H37.6875Z",
    fill: "#415360"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5469 49.125H42.4531V51.0312H40.5469V49.125Z",
    fill: "#E6E8EC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5 36.7344C48.3432 36.7344 53.8906 31.1869 53.8906 24.3438C53.8906 17.5006 48.3432 11.9531 41.5 11.9531C34.6568 11.9531 29.1094 17.5006 29.1094 24.3438C29.1094 31.1869 34.6568 36.7344 41.5 36.7344Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    filter: "url(#brightness)",
    d: "M41.5 30.0625L35.7812 27.2031V21.4844L41.5 18.625L47.2188 21.4844V27.2031L41.5 30.0625Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppropriatenessAssessmentQuestionTwo);
export default __webpack_public_path__ + "static/media/AppropriatenessAssessmentQuestionTwo.ffc8a61aef57a13d5f49495a54c4f407.svg";
export { ForwardRef as ReactComponent };